export default function SignedOutPage() {
  return <main className="state-page"><div className="state-card"><span className="status-label" role="status">Signed out</span><h1>Session ended</h1><p>You can close this tab or return to the dashboard.</p><a className="button-link" href="/">Return to sign in</a></div></main>;
}
